var _defs, _polygon, _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModelingGeometryCleanupSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}.cls-2{fill:#aeaeb6;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ModelingGeometryCleanup_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.29 29.71 1.75 29.71 1.58 32 2.71 32 2.77 30.73 2.82 32 3.77 32 3.92 30.73 4.08 32 5.08 32 5.33 30.28 5.73 31.96 8.2 32 8.27 30.92 8.49 32 11.89 32 12.04 30.28 12.35 32 13.28 32 13.54 30.53 13.82 31.96 16.1 32 16.36 30.92 16.43 32 16.94 32 17 30.28 17.16 32 18.45 32 18.29 29.71"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9,
    y: 4.93,
    width: 2,
    height: 19
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11,1.93a1,1,0,0,0-2,0v2h2ZM10,3a.5.5,0,1,1,.5-.5A.5.5,0,0,1,10,3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.28,27.49a1,1,0,0,0-.9-.56H13l-.72-1.44a1,1,0,0,0-.9-.56H8.62a1,1,0,0,0-.9.56L7,26.93H3.62a1,1,0,0,0-.9.56L2,28.93H18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.84,26c-2,.75-.89,2-2,2a2,2,0,0,1-2-2c0-1.1,2.32.35,2-2C28.7,22.91,31.88,25.61,30.84,26Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.29,21c1.31.18-1.11,2.7-2.4,2.4-2.5-.58-4.49-2.11-2.4-2.4,1.31-.19,1.07-2.4,2.4-2.4S24.89,20.66,27.29,21Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.84,28a2,2,0,0,1-4,0c0-1.1.9,0,2,0S24.84,26.9,24.84,28Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelingGeometryCleanupSvg);
export default __webpack_public_path__ + "static/media/ModelingGeometryCleanup_svg.976b6cffd4cdd4e7fed188cf050e9258.svg";
export { ForwardRef as ReactComponent };